import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'section'];

  connect() {
    // Initially hide all sections except the first one
    this.sectionTargets.forEach((section, index) => {
      if (index !== 0) {
        section.classList.add('hidden');
      }
    });

    // Set the first tab as active
    if (this.tabTargets.length > 0) {
      this.activateTab(this.tabTargets[0]);
    }
  }

  switchTab(event) {
    event.preventDefault();
    this.activateTab(event.currentTarget);
  }

  activateTab(tab) {
    // Get the target section ID
    const targetId = tab.getAttribute('href').substring(1);

    // Deactivate all tabs
    this.tabTargets.forEach((tabElement) => {
      tabElement.classList.remove('border-blue-600', 'dark:border-blue-500', 'text-blue-600', 'dark:text-blue-500');
      tabElement.classList.add('border-transparent', 'text-gray-500', 'dark:text-gray-400');
    });

    // Activate the selected tab
    tab.classList.remove('border-transparent', 'text-gray-500', 'dark:text-gray-400');
    tab.classList.add('border-blue-600', 'dark:border-blue-500', 'text-blue-600', 'dark:text-blue-500');

    // Hide all sections
    this.sectionTargets.forEach((section) => {
      section.classList.add('hidden');
    });

    // Show the target section
    const targetSection = this.element.querySelector(`#${targetId}`);
    if (targetSection) {
      targetSection.classList.remove('hidden');
    }
  }
}
